import React from "react";

import styled from "styled-components";

import colors from "constants/palette";

import { Header } from "components/App/styled";

export default function App({ paymentList, productList, customer }) {
  const total = productList
    .map((item) => ({ amount: item.amount, price: item.price }))
    .reduce((a, b) => Number(a) + Number(b.amount) * Number(b.price), 0);

  return (
    <Container>
      <div style={{ width: "100%" }}>
        <CustomerName>نام مشتری : {customer}</CustomerName>
        <Header> فاکتور</Header>
        <Table>
          <TableRow>
            <span className="cell title-row">نام کالا</span>
            <span className="cell" style={{ borderLeft: "1px solid #3a4041" }}>
              تعداد
            </span>
            <span className="cell" style={{ maxWidth: 180 }}>
              قیمت
            </span>
          </TableRow>
          {productList?.length
            ? productList.map((item, index) => (
                <TableRow key={index}>
                  <span className="cell title-row">{item.title}</span>
                  <span
                    className="cell"
                    style={{ borderLeft: "1px solid #3a4041" }}
                  >
                    {item.amount}
                  </span>
                  <span className="cell" style={{ maxWidth: 180 }}>
                    {item.price}
                  </span>
                </TableRow>
              ))
            : null}
        </Table>
      </div>

      <div style={{ width: "100%", marginTop: 24 }}>
        <Header> پرداختی ها</Header>
        <Table>
          <TableRow>
            <span className="cell" style={{ borderLeft: "1px solid #3a4041" }}>
              نوع
            </span>
            <span className="cell" style={{ borderLeft: "1px solid #3a4041" }}>
              مبلغ
            </span>
            <span className="cell" style={{ borderLeft: "1px solid #3a4041" }}>
              زمان
            </span>
          </TableRow>
          {paymentList?.length
            ? paymentList.map((item, index) => (
                <TableRow key={index}>
                  <span
                    className="cell"
                    style={{ borderLeft: "1px solid #3a4041" }}
                  >
                    {item.type === 0 ? "نقدی" : "چک"}
                  </span>
                  <span
                    className="cell"
                    style={{ borderLeft: "1px solid #3a4041" }}
                  >
                    {item.amount}
                  </span>
                  <span
                    className="cell"
                    style={{ borderLeft: "1px solid #3a4041" }}
                  >
                    {new Date(item.time).toLocaleDateString("fa-Ir")}
                  </span>
                </TableRow>
              ))
            : null}
        </Table>
        <div style={{ marginTop: 12 }}>مجموع : {total}</div>
      </div>
    </Container>
  );
}
const Container = styled.div`
  width: 98%;
  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

const Table = styled.div`
  border: 1px solid ${colors.primary};
  border-radius: 3px;
  overflow-x: auto;
  border-bottom: none;
`;
const TableRow = styled.div`
  border-bottom: 1px solid ${colors.primary};
  display: flex;
  & .cell {
    width: 50%;
    text-align: center;
    padding: 3px 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  & .title-row {
    border-left: 1px solid #3a4041;
    width: 40%;
    display: block;
    text-align: start;
    display: flex;
    align-items: center;
  }
`;

const CustomerName = styled.div`
  margin-bottom: 18px;
  font-size: 1rem;
`;
